import { render, staticRenderFns } from "./VonexSearch.vue?vue&type=template&id=19ffb650"
import script from "./VonexSearch.vue?vue&type=script&lang=js"
export * from "./VonexSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports